export default "__VITE_ASSET__daec520b__"